import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Dropdown } from "primereact/dropdown";
import ReportsMessages from "reports/intl/ReportsMessages";
import ReportsConstants from "reports/utils/ReportsConstants";

const { ALL, ACTIVE, INACTIVE } = ReportsConstants;

const dropdownStyle = { width: "9rem" };

const StatusFilter = ({ filterApplyCallback, value }) => {
  const { formatMessage } = useIntl();

  const handleChange = useCallback(
    (evt) => {
      filterApplyCallback(evt.value);
    },
    [filterApplyCallback]
  );

  const ddlOpts = useMemo(() => {
    const statusMap = [ACTIVE, INACTIVE, ALL].reduce((acc, status) => {
      acc[status] = {
        id: status,
        name: formatMessage(ReportsMessages[status.toLowerCase()]),
      };
      return acc;
    }, {});
    const data = Object.values(statusMap);
    return data.map(({ id, name }) => ({ id, name }));
  }, [formatMessage]);

  return (
    <Dropdown
      dataKey="status"
      onChange={handleChange}
      optionLabel="name"
      options={ddlOpts}
      optionValue="id"
      resetFilterOnHide
      style={dropdownStyle}
      value={value}
    />
  );
};

StatusFilter.propTypes = {
  filterApplyCallback: PropTypes.func,
  value: PropTypes.string,
};

export default StatusFilter;
